import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { StripeTaxRate } from '@/modules/billing/models/stripe/StripeTaxRate';

export class StripeTax extends BaseModel {
  public amount: number;

  public rate: Relationship<StripeTaxRate>;

  constructor(model: Partial<StripeTax> = {}) {
    super();

    this.amount = model.amount as number;
    this.rate = StripeTaxRate.mapModel(model.rate);
  }
}
